import { render } from "./ManagerViewForum.vue?vue&type=template&id=8005c0d8"
import script from "./ManagerViewForum.vue?vue&type=script&lang=js"
export * from "./ManagerViewForum.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__